import type { SnapshotComparison } from "@board-preserve/contracts";

export type ComparisonChangeKind = "added" | "changed" | "moved" | "removed";

export function comparisonSelectionIsAvailable(
  snapshotIds: Iterable<string>,
  fromSnapshotId: string,
  toSnapshotId: string,
): boolean {
  const available = new Set(snapshotIds);
  return (
    fromSnapshotId !== toSnapshotId &&
    available.has(fromSnapshotId) &&
    available.has(toSnapshotId)
  );
}

export function comparisonChangeTotals(
  comparison: SnapshotComparison,
): Record<ComparisonChangeKind, number> {
  return Object.values(comparison.collections).reduce(
    (totals, collection) => ({
      added: totals.added + collection.added,
      changed: totals.changed + collection.changed,
      moved: totals.moved + collection.moved,
      removed: totals.removed + collection.removed,
    }),
    { added: 0, changed: 0, moved: 0, removed: 0 },
  );
}

export function readableComparisonToken(value: string): string {
  const words = value
    .replaceAll("_", " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .trim()
    .toLowerCase();
  return words.length === 0
    ? value
    : words.charAt(0).toUpperCase() + words.slice(1);
}
